module.exports = __webpack_public_path__ + "img/Comment_ca_marche_4.5842de4a.webp";